module.exports = __webpack_public_path__ + "assets/unpkg.929fc811.svg";